import React from "react";

function Contact() {
  return (
    <div className="page">
      <h2>Contact Us 📩</h2>
      <p>Email: genzskills19@gmail.com</p>
      <p>Phone: +91-9652320194</p>
    </div>
  );
}

export default Contact;
